document.addEventListener('DOMContentLoaded', function() {
  var form = document.querySelector('form[action*="/cart/add"]');
  var inputField = document.getElementById('custom-instructions');

  if (form && inputField) {
    form.addEventListener('submit', function(event) {
      if (inputField.value.trim() === '') {
        event.preventDefault();
        alert('Bitte geben Sie spezielle Bestellanweisungen ein.');
        inputField.focus();
      }
    });

    // PayPal Button validierung
    var paypalButton = document.querySelector('.paypal-button'); // Update selector based on actual button class
    if (paypalButton) {
      paypalButton.addEventListener('click', function(event) {
        if (inputField.value.trim() === '') {
          event.preventDefault();
          alert('Bitte geben Sie spezielle Bestellanweisungen ein.');
          inputField.focus();
        }
      });
    }
  }
});
